import { StateCreator } from 'zustand';
import CheckoutErrorObj, { generateUnknownErrorMessage } from '@/lib/checkout/CheckoutErrorObj';
import { CheckoutErrorName } from '@/types/checkout';
import { CHECKOUT_ERRORS, CONFIRM_REDIRECT_ERROR_CTX } from '@/constants/checkout';

export interface ErrorSlice {
  checkoutError?: CheckoutErrorObj;
  setCheckoutError: (error: CheckoutErrorObj) => void;
  clearCheckoutError: () => void;
  paymentConfirmError?: CheckoutErrorObj;
  setPaymentConfirmError: (error: CheckoutErrorName, e?: Error) => void;

  clearErrors: () => void;
}

export const createErrorSlice: StateCreator<ErrorSlice, [], [], ErrorSlice> = (set) => ({
  checkoutError: undefined,
  setCheckoutError: (error: CheckoutErrorObj) => set({ checkoutError: error }),
  clearCheckoutError: () => set({ checkoutError: undefined, paymentConfirmError: undefined }),
  paymentConfirmError: undefined,
  setPaymentConfirmError: (errorName, e) => {
    const { ctx, displayMessage } = CHECKOUT_ERRORS[errorName]
      ? CHECKOUT_ERRORS[errorName]
      : { ctx: CONFIRM_REDIRECT_ERROR_CTX, displayMessage: generateUnknownErrorMessage(e) };
    const error = new CheckoutErrorObj(
      errorName,
      'An error occurred during payment confirmation.',
      displayMessage,
      ctx,
      e
    );
    set({
      paymentConfirmError: error,
    });
  },
  clearErrors: () => set({ checkoutError: undefined, paymentConfirmError: undefined }),
});
